import { Component, OnInit, OnDestroy, ChangeDetectorRef, NgZone } from "@angular/core";
import { LoaderService, Notificacao } from "./loader.service";
import * as moment from "moment";

@Component({
  selector: "app-loader",
  templateUrl: "./loader.component.html",
  styleUrls: ["./loader.component.scss"],
})
export class LoaderComponent implements OnInit, OnDestroy {
  constructor(public loader: LoaderService, private cdr: ChangeDetectorRef, private ngZone: NgZone) {}
  notificoes: Notificacoes = [];
  mon = moment;
  private intervalId: any;

  ngOnInit() {
    this.loader.setnotifica().subscribe(data => {
      this.notificoes.push(data);
    });
    this.loader.setdismiss().subscribe(data => {
      this.notificoes.map((e, i) => {
        this.notificoes.splice(i, 1);
      });
    });

    // Start a timer to update elapsed time every second
    this.ngZone.runOutsideAngular(() => {
      this.intervalId = setInterval(() => {
        this.ngZone.run(() => {
          this.cdr.detectChanges();
        });
      }, 1000);
    });
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  getElapsedTime(not: Notificacao): string {
    const diffMinutes = this.mon().diff(not.date, "minutes");
    if (diffMinutes === 0) {
      return this.mon().diff(not.date, "seconds") + " segundos";
    } else {
      return diffMinutes + " minuto(s)";
    }
  }
}

export interface Notificacoes extends Array<Notificacao> {}
